import React from 'react';
import { memo } from 'react';
import classNames from 'classnames';
import { Button as ButtonMoly } from '@bfe/moly';
import { ButtonProps } from '@bfe/moly/dist/es/components/ui/button';
import { CheckIcon } from '@bfe/moly-icons';

import styles from './index.module.less';

interface Props extends ButtonProps {
  customType?: 'gradient';
}

export const Button = memo(function Button({
  customType,
  ...props
}: Props & React.HTMLAttributes<HTMLButtonElement>) {
  if (customType === 'gradient') {
    return (
      <ButtonMoly
        {...props}
        className={classNames(props?.className, styles.gradient)}
      >
        <span>{props.children}</span>
      </ButtonMoly>
    );
  }

  if (props.variant === 'secondaryBrand') {
    return (
      <ButtonMoly
        {...props}
        className={classNames(props?.className, styles.secondaryBrand)}
      >
        <span>{props.children}</span>
      </ButtonMoly>
    );
  }

  if (props.variant === 'secondary') {
    return (
      <ButtonMoly
        {...props}
        className={classNames(props?.className, styles.secondaryS)}
      >
        <CheckIcon className={styles.checkIcon} />
        <span>{props.children}</span>
      </ButtonMoly>
    );
  }

  return (
    <ButtonMoly
      {...props}
      className={classNames(
        props?.className,
        styles[props.variant || 'default']
      )}
    />
  );
});
